// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.selectAssetHeader
{
    width: 100%;
    height: 80px;
    text-align: left;
    overflow: hidden;
}

.selectAssetBody
{
    width: 100%;
    height: calc(100% - 60px);
    text-align: left;

}`, "",{"version":3,"sources":["webpack://./src/applications/appcode/appcomponents/selectassets/selectassets.css"],"names":[],"mappings":"AAAA;;IAEI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;;IAEI,WAAW;IACX,yBAAyB;IACzB,gBAAgB;;AAEpB","sourcesContent":[".selectAssetHeader\n{\n    width: 100%;\n    height: 80px;\n    text-align: left;\n    overflow: hidden;\n}\n\n.selectAssetBody\n{\n    width: 100%;\n    height: calc(100% - 60px);\n    text-align: left;\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
